import { createApp } from 'vue';
import CameraSelector from '../components/CameraSelector.vue';

// Mount app when DOM is ready
const mountElement = document.getElementById('camera-selector-app');
if (mountElement) {
    const apiUrl = mountElement.dataset.apiUrl;
    const defaultSensorType = mountElement.dataset.defaultSensorType || 'all';
    const hideFamilyGrouping = mountElement.dataset.hideFamilyGrouping === 'true';
    const translations = mountElement.dataset.translations
        ? JSON.parse(mountElement.dataset.translations)
        : {};

    const app = createApp(CameraSelector, {
        apiUrl: apiUrl,
        defaultSensorType: defaultSensorType,
        hideFamilyGrouping: hideFamilyGrouping,
        translations: translations,
    });

    app.mount('#camera-selector-app');
}
